/*
 * Copyright 2019 FedEx
 */
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonMethodUtilityService } from '../app/services/common-method-utility.service';
import { appConstants } from './app.constant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  currentYear: number;
  LOGO_REDIRECT: string;
  PRIVACY_POLICY_URL: string;
  unitTesting: boolean = false;
  subscriptionLang: Subscription;
  subscriptionCtry: Subscription;
  country: string;
  language: string;

  constructor(
    private commonMethodUtilityService: CommonMethodUtilityService
  ) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.getLink(null, null);
  }

  getLink(language: string, country: string) {
    let langCtryStr = this.commonMethodUtilityService.getLangCtryCombi(language, country);
    if (country && language) {
      this.LOGO_REDIRECT = environment.LOGO_REDIRECT_PART_1 + langCtryStr + environment.LOGO_REDIRECT_PART_2;
      this.PRIVACY_POLICY_URL = environment.PRIVACY_POLICY_URL_1 + langCtryStr + environment.PRIVACY_POLICY_URL_2;
    }
    else {
      this.LOGO_REDIRECT = environment.LOGO_REDIRECT_PART_1 + 'en-gb' + environment.LOGO_REDIRECT_PART_2;
      this.PRIVACY_POLICY_URL = environment.PRIVACY_POLICY_URL_1 + 'en-gb' + environment.PRIVACY_POLICY_URL_2;
    }
  }
}
